import Cookies from 'universal-cookie'
import { connect } from 'react-redux'
import {
  signin,
  setSigninData,
  setError,
  setErrorClean,
  signinGoogle,
} from 'reduxpath/ducks/Auth'

import googleErrorMessage from 'utils/StringFormat'

import Form from './units'

const cookies = new Cookies()

const mapStateToProps = state => ({
  auth: state.Auth,
})

const mapDispatchToProps = dispatch => ({
  submitSignin(auth) {
    return (e) => {
      e.preventDefault()

      if (!auth.signinData.password || !auth.signinData.email) {
        return dispatch(setError({ message: 'Email / Password is required' }))
      }

      const cbPostSignin = (response, err) => {
        if (err) {
          return err
        }
        if (response.token) {
          dispatch(setErrorClean())
          const currentDate = new Date()
          currentDate.setDate(currentDate.getDate() + 5)
          const cookiesOptions = {
            path: '/',
            expires: currentDate,
          }
          cookies.set('token', JSON.stringify(response.token), cookiesOptions)
          cookies.set('userId', JSON.stringify(response.user.id), cookiesOptions)
          window.location.replace('/')
        }
        return response
      }
      return dispatch(signin(auth.signinData, cbPostSignin))
    }
  },

  signinWithGoogle(data) {
    if (data.error) {
      const errorMessage = googleErrorMessage(data.error.error)
      return dispatch(setError({ message: errorMessage }))
    }

    const cbPostSignin = (response, err) => {
      if (err) {
        return err
      }
      if (response.token) {
        dispatch(setErrorClean())
        const currentDate = new Date()
        currentDate.setDate(currentDate.getDate() + 5)
        const cookiesOptions = {
          path: '/',
          expires: currentDate,
        }
        cookies.set('token', JSON.stringify(response.token), cookiesOptions)
        cookies.set('userId', JSON.stringify(response.user.id), cookiesOptions)
        window.location.replace('/')
      }
      return response
    }
    return dispatch(signinGoogle(data, cbPostSignin))
  },

  handleFormChange(auth) {
    return (e) => {
      const params = {
        signinData: {
          email: e.target.name === 'email'
            ? e.target.value
            : auth.signinData.email,
          password: e.target.name === 'password'
            ? e.target.value
            : auth.signinData.password,
        },
      }
      dispatch(setSigninData(params))
    }
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Form)
